<cdk-accordion-item #panel="cdkAccordionItem" [expanded]="expanded()" [disabled]="disabled()" class="block w-full">
  <button
    type="button"
    class="flex w-full items-center justify-between gap-3 px-4 py-3 text-left"
    [ngClass]="{ 'cursor-pointer': !disabled(), 'cursor-not-allowed opacity-60': disabled() }"
    [disabled]="disabled()"
    [attr.aria-expanded]="panel.expanded"
    [attr.aria-controls]="panel.id + '-body'"
    (click)="panel.toggle()"
  >
    <span class="flex flex-col min-w-0">
      <span class="flex items-center gap-2 text-sm font-semibold text-gray-900">
        @if (titleIcon()) {
          <ts-icon
            class="flex-shrink-0"
            [icon]="titleIcon()"
            [color]="resolveIconColor(titleIconColor())"
            size="small"
          />
        }
        <span class="truncate">{{ title() }}</span>
      </span>
      @if (description() || contentIcon()) {
        <span class="flex items-center gap-2 text-xs text-gray-500">
          @if (description()) {
            <span class="truncate">{{ description() }}</span>
          }
          @if (contentIcon()) {
            <ts-icon
              class="flex-shrink-0"
              [icon]="contentIcon()"
              [color]="resolveIconColor(contentIconColor())"
              [matTooltip]="contentIconTooltip() ?? ''"
              [matTooltipDisabled]="!contentIconTooltip()"
              size="small"
            />
          }
        </span>
      }
    </span>
    <ts-icon
      class="flex-shrink-0 text-gray-500"
      [icon]="panel.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
      size="small"
    />
  </button>

  <div
    role="region"
    class="border-t border-gray-100 px-4 py-3"
    [attr.id]="panel.id + '-body'"
    [attr.aria-labelledby]="panel.id"
    [style.display]="panel.expanded ? '' : 'none'"
  >
    <ng-content></ng-content>
  </div>
</cdk-accordion-item>
